export default __webpack_public_path__ + "static/bbc_vid-5eaacb58a5cd99976f7e119ee0cefbab.png";